import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ug-bachelor-of-business-administration-computer-application',
  templateUrl: './ug-bachelor-of-business-administration-computer-application.component.html',
  styleUrls: ['./ug-bachelor-of-business-administration-computer-application.component.scss']
})
export class UgBachelorOfBusinessAdministrationComputerApplicationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
